import { Box } from "@mui/material";
import { isComplexEntityType } from "../../../../../../utils/utils";
import JiraInteractionManager from "../../../../../stack/integrations/Jira/JiraInteractionManager";
import ExclusionInformationIcon from "../groupedControl/misconfigurations/ExclusionInformationIcon";
import MisconfigurationMoreActionsButton from "../groupedControl/misconfigurations/MisconfigurationMoreActionsButton";
import SnoozeInformationIcon from "../groupedControl/misconfigurations/SnoozeInformationIcon";
import {
  addToAssetColumn,
  getDisplayNameColumn,
  getExtraInfoColumn,
  getFirstDiscoveredColumn,
  getLabelColumn,
  getSimpleEntityDisplayNameColumn,
  getThirdInfoColumn,
} from "../shared/sharedColumns";

export default function getMisconfiguredEntitiesTableColumns(
  fullControl,
  entityType,
  colors,
  terminatedEntities,
  selectedExclusionTab
) {
  const addColumnsForComplexEntities = (columns, terminatedEntities) => {
    columns.push(addToAssetColumn);
    columns.push(getDisplayNameColumn(colors, terminatedEntities));
    columns.push(getExtraInfoColumn(entityType, colors));
    const thirdColumn = getThirdInfoColumn(entityType, colors);
    if (thirdColumn) {
      columns.push(thirdColumn);
    }
  };

  const addColumnsForSimpleEntities = (columns) => {
    columns.push(getSimpleEntityDisplayNameColumn(colors));
  };

  const columns = [];
  if (isComplexEntityType(entityType))
    addColumnsForComplexEntities(columns, terminatedEntities);
  else addColumnsForSimpleEntities(columns);

  columns.push(
    getFirstDiscoveredColumn(colors, (params) => {
      const misconfiguration = fullControl.misconfigurations.find(
        (misconfiguration) =>
          misconfiguration.entity_id === params.row.entity_id
      );
      return misconfiguration?.first_seen?.timestamp_utc || 0;
    })
  );

  columns.push(getLabelColumn());
  columns.push({
    field: "actions",
    headerName: "",
    align: "center",
    disableExport: true,
    sortable: false,
    maxWidth: 100,
    disableReorder: true,
    disableClickEventBubbling: true,
    resizable: false,
    renderCell: (params) => {
      const misconfiguration = fullControl.misconfigurations.find(
        (misconfiguration) =>
          misconfiguration.entity_id === params.row.entity_id
      );
      return (
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          gap={1}
          onClick={(e) => e.stopPropagation()}
        >
          {misconfiguration && !misconfiguration.is_excluded && (
            <JiraInteractionManager
              fullControl={fullControl}
              isPerMisconfiguration={true}
              selectedMisconfigurations={[misconfiguration]}
              sx={{
                height: "32px",
                border: "0px",
              }}
              hideTitle={true}
              hideTooltip={true}
            />
          )}

          {misconfiguration?.is_excluded && (
            <ExclusionInformationIcon misconfiguration={misconfiguration} />
          )}

          {misconfiguration?.is_snoozed && (
            <SnoozeInformationIcon misconfiguration={misconfiguration} />
          )}

          <MisconfigurationMoreActionsButton
            fullControl={fullControl}
            misconfiguration={misconfiguration}
            onEvidenceClick={() => {}}
          />
        </Box>
      );
    },
  });
  return columns;
}
